import { createContext, useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import CryptoJS from 'crypto-js';
import { ckeck_token_auth, loginuser, logout_user } from './ApiServices';
const AuthContext = createContext();
// Secret key for encryption (keep it secure)
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;
// Function to encrypt data
export const encryptData = (data) => {
  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString();
  return encryptedData;
};
// Function to decrypt data
export const decryptData = (encryptedData) => {
  try {
    if (!encryptedData) {
      return null;
    }
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    const decryptedData = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error('Error parsing JSON:', error);
    return null; // Return null or handle the error in a way that makes sense for your application
  }
};
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem('user');
    return storedUser ? decryptData(storedUser) : null;
  });

  const [isInPhone,setIsInPhone] = useState(false);
   const[refresh,setrefresh] = useState({});
  const [addtoCart,setAddToCart] = useState([]);
  const [counts,setCounts] = useState([]);
  const[wishlist,setWishList] = useState([])
  const [token, settoken] = useState(() => {
    const storedToken = localStorage.getItem('token');
    return storedToken ? decryptData(storedToken) : null;
  });

const [selectedBranch, setSelectedBranch] = useState(() => {
  const storedBranch = localStorage.getItem('selectedBranch');
  return storedBranch ? decryptData(storedBranch) : null;
});
const [selectedSession, setSelectedSession] = useState(() => {
  const storedBranch = localStorage.getItem('selectedSession');
  return storedBranch ? decryptData(storedBranch) : null;
});
  useEffect(() => {
    const handlePhone = () => {
      if (window.innerWidth <= 550) {
        setIsInPhone(true);
      } else {
        setIsInPhone(false); 
      }
    };
  
    // Initial call to set state based on current window size
    handlePhone();
  
    // Add resize event listener
    window.addEventListener("resize", handlePhone);
  
    // Cleanup function to remove event listener
    return () => {
      window.removeEventListener("resize", handlePhone);
    };
  }, []);
  

const fetchCounts =()=>{
  setCounts({...counts,notification:counts?.notification+1,cart:counts?.cart+1,wishlist:counts?.wishlist+1})
}

useEffect(()=>{
  fetchCounts();
},[])

  

  useEffect(() => {
    // Save user details to local storage whenever user state changes
    localStorage.setItem('user', encryptData(user));
    localStorage.setItem('token', encryptData(token));
   localStorage.setItem('selectedBranch', encryptData(selectedBranch));
   localStorage.setItem('selectedSession', encryptData(selectedSession));
  }, [user, token,selectedBranch,selectedSession]);
  const login = (data) => {
    return loginuser(data).then(res => {
      if (res.status) {
          settoken(res.response.token);
          setUser(res.response.data);
        return { status: true, response: res.response.data, message: res.response.message };
      } else {
        return { status: false, response: res.error, message: res.response.data.message };
      }
    })
  };

  const logout = () => {
    logout_user(token).then(res => {
      if (res.status) {
        localStorage.setItem('user', encryptData(null));
        localStorage.setItem('token', encryptData(null));
        localStorage.setItem('selectedBranch', encryptData(null));
       localStorage.setItem('selectedSession', encryptData(null));
        setSelectedBranch(null);
        setSelectedSession(null);
        settoken(null);
        setUser(null);
        toast.info("Logout Successfully!")
      }
    })
  };


  const checkValidToken = (usertoken) => {
    ckeck_token_auth({token:usertoken}).then(res => {
      if (res.status === false && res?.response?.status === 400){
          localStorage.setItem('user', encryptData(null));
          localStorage.setItem('token', encryptData(null));
          localStorage.setItem('selectedBranch', encryptData(null));
          localStorage.setItem('selectedSession', encryptData(null));
        setSelectedBranch(null);
        setSelectedSession(null);
          settoken(null);
          setUser(null);
      }
    })
  }

  
  const updateuser = () => {
    // refresh_user_detail({token:token}).then(res => {
    //   if (res.status) {
    //     setUser(res.response.data);
    //   }
    // })
  }
  return (
    <AuthContext.Provider value={{fetchCounts,setCounts,refresh,setrefresh,counts, selectedBranch, setSelectedBranch,setSelectedSession,selectedSession, user, token, login, logout, checkValidToken,updateuser,addtoCart,setAddToCart,wishlist,setWishList,isInPhone,setIsInPhone }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
